const STORAGE_KEY = "passPlayPlayers";

/** Default avatars: X → c1, O → c2 (same as lobby PVP slots). */
export const PASS_PLAY_DEFAULT_CHARACTERS = { xCharacter: "c1", oCharacter: "c2" };

function normalizePassPlayCharacter(value, fallback) {
  const s = String(value ?? "")
    .trim()
    .toLowerCase();
  if (/^c[1-6]$/.test(s)) return s;
  const n = Number(value);
  if (Number.isInteger(n) && n >= 1 && n <= 6) return `c${n}`;
  return fallback;
}

export function readPassPlayPlayers() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const xName = String(parsed?.xName ?? "").trim();
    const oName = String(parsed?.oName ?? "").trim();
    if (!xName || !oName) return null;
    return {
      xName,
      oName,
      xCharacter: normalizePassPlayCharacter(
        parsed?.xCharacter,
        PASS_PLAY_DEFAULT_CHARACTERS.xCharacter
      ),
      oCharacter: normalizePassPlayCharacter(
        parsed?.oCharacter,
        PASS_PLAY_DEFAULT_CHARACTERS.oCharacter
      ),
    };
  } catch {
    return null;
  }
}

export function savePassPlayPlayers({ xName, oName, xCharacter, oCharacter }) {
  const players = {
    xName: String(xName ?? "").trim(),
    oName: String(oName ?? "").trim(),
    xCharacter: normalizePassPlayCharacter(
      xCharacter,
      PASS_PLAY_DEFAULT_CHARACTERS.xCharacter
    ),
    oCharacter: normalizePassPlayCharacter(
      oCharacter,
      PASS_PLAY_DEFAULT_CHARACTERS.oCharacter
    ),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(players));
  return players;
}

export function clearPassPlayPlayers() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function winnerLabel({ winner, isDraw, players }) {
  if (isDraw) return "Draw";
  if (!winner || !players) return winner ?? "";
  if (winner === "X") return players.xName;
  if (winner === "O") return players.oName;
  return String(winner);
}

/** Player 1 = X, player 2 = O. Winner 1, loser 0; draw both 0. */
export function computePassPlayPoints({ winner, isDraw }) {
  if (isDraw || !winner) {
    return { player1points: 0, player2points: 0 };
  }
  return {
    player1points: winner === "X" ? 1 : 0,
    player2points: winner === "O" ? 1 : 0,
  };
}
